import solidBullet from '../../../../assets/dashboard-svg/solid-bullet.svg';
import dashedBullet from '../../../../assets/dashboard-svg/dashed-bullet.svg';
import solidBulletInactive from '../../../../assets/dashboard-svg/solid-bullet-inactive.svg';
import { colors } from '../../../../theme/color-palette';
import {
	THIS_YEAR,
	LAST_YEAR,
	NETSALES,
	ONHAND_INVENTORY,
} from '../../../../constants/constant';
import { convertToTwoDecimal } from '../../../../helper/convertAmount';

const { FONT_COLOR, GREY } = colors;

export const salesTooltipFormat = (inStock, weekFilter, showWeekDates) => {
	const tooltipHeader = `${
		[4, 13, 26, 52].includes(weekFilter) && showWeekDates
			? '({trend_wkStartDt.formatDate("MM/dd/yy")} - {trend_wkEndDt.formatDate("MM/dd/yy")})'
			: ''
	}`;
	return `<div style="font-size: 12px; width: 280px; text-align: left; color: ${FONT_COLOR}" >
    <div style="width: 100%; margin: 12px 0 0 28px; color: ${GREY}; "> {categoryX} {dateX.formatDate("MM/dd")} ${tooltipHeader} </div>
    <div style="width: 100%; margin: 16px 0 0 12px;">
        <div style="display: inline-block; width: 50%; line-height: 14px;""> 
            <img style="margin: 0 4px;" src =${solidBullet} />${THIS_YEAR}<img style="margin: 4px; margin-bottom: 0px;" src={arrow_comp} />
            <span style="color: {color_perc}; font-size: 10px">{diff_perc}</span>
        </div>
        <div style="display: inline-block; width: 40%; line-height: 16px; text-align: right">{trend_ty_value}${inStock}</div>
    </div>
    <div style="width: 100%; margin: 16px 0 24px 12px;">
        <div style="display: inline-block; width: 50%;"> 
            <img style="width: 8px; margin: 0 4px;" src =${dashedBullet} />${LAST_YEAR}</div>
        <div style="display: inline-block; width: 40%; line-height: 16px; text-align: right">{trend_ly_value}${inStock}</div>
    </div>
    </div>`;
};

export const inventoryTooltipFormat = (weekFilter, showWeekDates) => {
	const tooltipHeader = `${
		[4, 13, 26, 52].includes(weekFilter) && showWeekDates
			? '({trend_wkStartDt.formatDate("MM/dd/yy")} - {trend_wkEndDt.formatDate("MM/dd/yy")})'
			: ''
	}`;
	return `<div style="font-size: 12px; width: 280px; text-align: left; color: ${FONT_COLOR}" >
    <div style="width: 100%; margin: 12px 0 0 12px; color: ${GREY}; "> {categoryX} {dateX.formatDate("MM/dd")} ${tooltipHeader}</div>
    <div style="width: 100%; margin: 16px 0 0 12px;">
        <div style="display: inline-block; width: 50%; line-height: 14px;""> 
            <img style="margin: 0 2px;" src =${solidBulletInactive} /> ${NETSALES}
        </div>
        <div style="display: inline-block; width: 40%; font-weight: 500; line-height: 16px; text-align: right">{trend_net_sales_value} </div>
    </div>
    <div style="width: 100%; margin: 16px 0 24px 12px;">
        <div style="display: inline-block; width: 50%; line-height: 14px;"> 
            <img style="margin: 0 2px;" src =${solidBullet} /> ${ONHAND_INVENTORY} Inventory
        </div>
        <div style="display: inline-block; width: 40%; font-weight: 500; line-height: 16px; text-align: right">{trend_on_hand_value} </div>
    </div>
    </div>`;
};

export const createMetricsTooltip = () => {
	return `<div style="font-size: 12px; width: 280px; text-align: left; color: ${FONT_COLOR}" >
    <div style="width: 100%; margin: 12px 0 0 28px; color: ${GREY}; "> {categoryX} {dateX.formatDate("MM/dd")}</div>
    <div style="width: 100%; margin: 16px 0 12px 12px;">
        <div style="display: inline-block; width: 50%; line-height: 14px;""> 
            <img style="margin: 0 4px;" src =${solidBullet} />${THIS_YEAR}
        </div>
        <div style="display: inline-block; width: 40%; line-height: 16px; text-align: right">{yAxis}</div>
    </div>`;
};

export const getPercentageDiff = (item) => {
	if (Number(item.lyValue) === 0) {
		return 'NA';
	}
	return convertToTwoDecimal((item.tyValue / item.lyValue) * 100) - 100 || 0;
};

export const getStockDiffPer = (item) => {
	return convertToTwoDecimal(item.tyValue - item.lyValue, true);
};

//replenishment doesn't have last year value
export const replenishmentTooltipFormat = (symbol) => {
	return `<div style="font-size: 12px; width: 280px; text-align: left; color: ${FONT_COLOR}" >
    <div style="width: 100%; margin: 12px 0 0 28px; color: ${GREY}; "> {categoryX} {dateX.formatDate("MM/dd")}</div>
    <div style="width: 100%; margin: 16px 0 0 12px;">
        <div style="display: inline-block; width: 50%; line-height: 14px;""> 
            <img style="margin: 0 4px;" src =${solidBullet} />${THIS_YEAR}<img style="margin: 4px; margin-bottom: 0px;"/>
        </div>
        <div style="display: inline-block; width: 40%; line-height: 16px; text-align: right">{trend_ty_value}${symbol}</div>
    </div>
    <div style="width: 100%; margin: 16px 0 24px 12px;">
    </div>
    </div>`;
};

export const wosTooltipFormat = (tabName) => {
	const tooltipHeader = `${'({trend_wkStartDt.formatDate("MM/dd/yy")} - {trend_wkEndDt.formatDate("MM/dd/yy")})'}`;
	return `<div style="font-size: 12px; width: 280px; text-align: left; color: ${FONT_COLOR}" >
    <div style="width: 100%; margin: 12px 0 0 12px; color: ${GREY}; "> {categoryX} {dateX.formatDate("MM/dd")} ${tooltipHeader} </div>
    <div style="width: 100%; margin: 16px 0 12px 12px;">
        <div style="display: inline-block; width: 50%; line-height: 14px;""> 
            <img style="margin: 0 4px 0 0;" src =${solidBullet} />Week of supply-${tabName}<img style="margin: 4px; margin-bottom: 0px;"/>
        </div>
        <div style="display: inline-block; width: 40%; line-height: 16px; text-align: right">{trend_wos}</div>
    </div>
    </div>`;
};
